<script>
import { mapActions } from "vuex";

export default {
	data() {
		return {
			drawer: false,
			mdAndUp: window.innerWidth > 600
		};
	},
	methods: {
		...mapActions("session", ["logout"]),
		toggleSidebar() {
			this.drawer = !this.drawer;
			if (this.mdAndUp) {
				const el = document.getElementById("mainContent");
				const menu = document.getElementById("navigationDrawer");
				if(this.drawer) {
					el.style.paddingLeft = "256px";
					menu.style.width = "256px";
				}else{
					el.style.paddingLeft = "0";
					menu.style.width = "0";
				}
			}
		}
	},
};
</script>

<template>
	<div>
		<v-app-bar
			color="primary"
			dark
			app
			:clipped-left="mdAndUp"
		>
			<v-app-bar-nav-icon @click="toggleSidebar"></v-app-bar-nav-icon>
			<router-link
				v-if="this.$route.name !== 'status'"
				:to="{name: 'status'}"
			>
				<v-icon>mdi-arrow-left</v-icon>
			</router-link>
			<v-spacer/>
			<v-toolbar-title>Zegeba Server Status</v-toolbar-title>
			<v-spacer/>
		</v-app-bar>

		<v-navigation-drawer
			v-model="drawer"
			id="navigationDrawer"
			:permanent="drawer && mdAndUp"
			:temporary="!mdAndUp"
			app
			fixed
			:clipped="mdAndUp"
			:hide-overlay="mdAndUp"
		>
			<v-list
				nav
				dense
			>
				<v-list-item-group>
					<v-list-item :to="{name: 'users'}">
						<v-list-item-icon>
							<v-icon>mdi-account-multiple</v-icon>
						</v-list-item-icon>
						<v-list-item-title>Users</v-list-item-title>
					</v-list-item>
				</v-list-item-group>

				<v-list-item-group>
					<v-list-item @click="logout">
						<v-list-item-icon>
							<v-icon>mdi-logout</v-icon>
						</v-list-item-icon>
						<v-list-item-title>Logout</v-list-item-title>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>
	</div>
</template>

<style scoped>
.v-toolbar__title {
	color: rgba(255, 255, 255, .87);
}
</style>


// WEBPACK FOOTER //
// src/components/layout/TopNavbar.vue